import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAdminBooking, IConfirmMeetingRequest } from '../../../../assets/types/dtoTypes';

@Component({
  selector: 'app-confirm-meeting-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './confirm-meeting-modal.component.html',
  styleUrls: ['./confirm-meeting-modal.component.scss'],
})
export class ConfirmMeetingModalComponent {
  private dialogRef = inject(MatDialogRef<ConfirmMeetingModalComponent>);
  data = inject<{ booking: IAdminBooking }>(MAT_DIALOG_DATA);

  meetingLink = '';
  notes = '';

  get isValid(): boolean {
    return this.meetingLink.trim().length > 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.isValid) return;
    const result: IConfirmMeetingRequest = {
      meetingLink: this.meetingLink.trim(),
      notes: this.notes.trim() || undefined,
    };
    this.dialogRef.close(result);
  }
}
